import { doc, getDocs, query, runTransaction, where } from 'firebase/firestore';
import { db, collectionRef, instructorDoc, studentSubCol } from '../firebase/config';
import { COLLECTIONS } from '../utils/constants';
import { withRetry } from '../utils/firestoreRetry';
import { normalizeEmail } from '../utils/emailUtils';

export async function submitInstructorRating(studentId, instructorEmail, rating) {
  const normalizedEmail = normalizeEmail(instructorEmail);
  const qInst = query(
    collectionRef(COLLECTIONS.INSTRUCTORS),
    where('emailOrPhone', '==', normalizedEmail)
  );
  const snap = await getDocs(qInst);
  if (snap.empty) throw new Error('Eğitmen bulunamadı.');

  const instId = snap.docs[0].id;
  const reviewRef = doc(studentSubCol(studentId, 'instructorReviews'), instId);

  await withRetry(() =>
    runTransaction(db, async (t) => {
      const reviewSnap = await t.get(reviewRef);
      if (reviewSnap.exists()) {
        throw new Error('Bu eğitmeni zaten değerlendirdiniz.');
      }

      const instRef = instructorDoc(instId);
      const instSnap = await t.get(instRef);
      if (!instSnap.exists()) throw new Error('Eğitmen bulunamadı.');

      const data = instSnap.data();
      t.set(reviewRef, {
        rating,
        instructorEmail: normalizedEmail,
        timestamp: Date.now(),
      });
      t.update(instRef, {
        ratingSum: (data.ratingSum || 0) + rating,
        ratingCount: (data.ratingCount || 0) + 1,
      });
    })
  );
}
